ux-iws-teaser-download-tile {
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    height: 100%;
}

.ux-iws-teaser-download-tile {
    background-color: $color-white;
    cursor: pointer;
    box-shadow: 0 0 22px transparentize($color-black, 0.92);
    width: 100%;

    h3,
    h4,
    h5,
    p,
    ux-tag {
        margin: 0;
    }

    &__inner {
        box-sizing: border-box;
        position: relative;
        display: flex;
        align-items: stretch;
        flex-flow: row nowrap;
        width: 100%;
        height: 100%;
    }

    &__image {
        box-sizing: border-box;
        display: none;
        align-items: flex-start;
        justify-content: center;
        flex: 0 0 auto;
        width: 130px;
        min-height: 180px;
        height: 100%;
        border: 5px solid $color-white;

        &:empty {
            display: none;
        }

        > *,
        img {
            flex: 1 1 auto;
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: 50% 0;
        }

        @media screen and (min-width: 768px) {
            display: flex;
        }
    }

    &__header {
        flex: 0 0 auto;
        margin: 0 0 10px;
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: flex-start;
        gap: 10px;
        min-height: 30px;
    }

    &__content {
        box-sizing: border-box;
        flex: 1 1 auto;
        padding: 20px 30px;

        @media screen and (min-width: 768px) {
            padding-left: 25px;
            max-width: calc(100% - 130px);
        }
    }

    &__info {
        font-size: $size-text-small;
        color: $color-gray-text;
        display: inline-block;
    }

    &__description {
        line-height: 1.3;
        padding-right: 60px;
        hyphens: auto;

        [slot="title"] {
            font-size: $size-text-title-bold;
            margin: 5px 0;
        }

        [slot="description"] {
            margin: 0;
            color: $color-gray-text;
        }
    }

    &__actions {
        flex: 0 0 auto;
        align-self: flex-end;
        padding: 0 30px 30px 0;
        position: absolute;
        right: 0;
        bottom: 0;
    }
}

.ux-iws-teaser-download-tile-grid {
    @supports (display: grid) {
        display: grid;
        grid-column-gap: 30px;
        grid-row-gap: 30px;
        grid-template-columns: 100%;

        @media screen and (min-width: 1200px) {
            grid-template-columns: calc(50% - 15px) calc(50% - 15px);
        }
    }

    @supports not (display: grid) {
        display: flex;
        flex-flow: row wrap;
        margin: -15px;

        ux-iws-teaser-download-tile {
            flex: 1 0 auto;
            padding: 15px;
        }
    }
}
